import { render, staticRenderFns } from "./repayment-loan-overdue.vue?vue&type=template&id=2d204e07&"
import script from "./repayment-loan-overdue.vue?vue&type=script&lang=js&"
export * from "./repayment-loan-overdue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports